// A lazy route chunk failed to load. The classic cause: the user is holding a
// pre-deploy index.html and the deploy's --delete pass has removed the old hashed
// assets, so the dynamic import of a code-split module (RunPage, JournalTerminal)
// rejects. Message shapes vary by browser/bundler: Chrome/Vite throws a TypeError
// "Failed to fetch dynamically imported module: ...", Firefox "error loading
// dynamically imported module", Safari "Importing a module script failed", and
// webpack-style stacks use the ChunkLoadError name.
export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return (
    error.name === 'ChunkLoadError' ||
    /failed to fetch dynamically imported module|error loading dynamically imported module|importing a module script failed/i.test(
      error.message,
    )
  );
}
